import React from 'react'
import { string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Markdown from 'components/atoms/MarkdownContent'

const FacultyDescription = ({ description }) => (
  <div className="faculty-description">
    <SectionContainer
      paddingTop={80}
    >
      <Container>
        <SectionTitle title="Informasi Umum" />
        <Markdown className="faculty-description__content" content={description} />
      </Container>
    </SectionContainer>
  </div>
)

FacultyDescription.propTypes = {
  description: string,
}

export default FacultyDescription
